interface DillToggleProps {
  value: boolean;
  onChange: (v: boolean) => void;
  size?: number;
  isDisabled?: boolean;
}

export const DillToggle = ({ value, onChange, size = 16, isDisabled = false }: DillToggleProps) => {
  const currentSize = size;
  const height = currentSize + 2;
  const width = currentSize * 2 + 2;

  return (
    <button
      type="button"
      disabled={isDisabled}
      onClick={() => onChange(!value)}
      style={{ height, width }}
      className={`relative inline-flex flex-shrink-0 items-center rounded-full transition-colors focus:outline-none ${
        isDisabled ? 'opacity-50 cursor-not-allowed' : ''
      } ${value ? 'bg-blue-500' : 'bg-gray-500/80'}`}>
      <span
        style={{
          height: currentSize,
          width: currentSize,
          transform: value ? `translateX(${currentSize + 1}px)` : `translateX(1px)`,
        }}
        className="inline-block rounded-full bg-white shadow transition-transform"
      />
    </button>
  );
};
